// extracted by mini-css-extract-plugin
export default {"mainlogin":"login_mainlogin__3Ex8f"};